export default function ChangePassword({ contentData, initError, initLoader }) {
  return <div>This is Change Password page</div>;
}
